(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-static/map-static.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-static/map-static.js');

'use strict';

const {
  useEffect,
  useMemo
} = React;
const {
  getStaticMapHandler
} = svs.tur.lyckoplatsen.map;
const {
  mapDefaults
} = svs.tur.lyckoplatsen.map;

const MapStatic = _ref => {
  let {
    lat,
    lng,
    locationName,
    charity,
    useSmallIcon = false,
    errorCallback
  } = _ref;
  const mapHandlerStatic = useMemo(() => getStaticMapHandler(), []);
  const staticId = _.uniqueId('map-static-');
  useEffect(() => {
    const coord = {
      lat: String(lat).replace(',', '.'),
      lng: String(lng).replace(',', '.')
    };
    const mapOptions = {
      nodeId: staticId,
      center: [coord.lat, coord.lng],
      dragging: false,
      zoom: mapDefaults.maxZoom,
      zoomControl: false,
      scrollWheelZoom: false,
      keyboard: false,
      doubleClickZoom: false,
      boxZoom: false,
      touchZoom: false,
      tap: false
    };
    mapHandlerStatic.createMap({
      mapOptions,
      coord,
      charity,
      locationName,
      useSmallIcon,
      errorCallback: () => {
        errorCallback === null || errorCallback === void 0 || errorCallback();
      }
    });
    return () => mapHandlerStatic.removeMap();
  }, [lat, lng, mapHandlerStatic, staticId, charity, locationName, useSmallIcon, errorCallback]);
  return React.createElement("div", {
    className: "lyckoplatsen-map-static",
    id: staticId,
    style: {
      height: '100%',
      width: '100%',
      zIndex: 0
    }
  });
};
Object.assign(svs.tur.lyckoplatsen.map, {
  MapStatic
});

 })(window);